import { render, staticRenderFns } from "./Assinatura.vue?vue&type=template&id=8da88f4e&"
import script from "./Assinatura.js?vue&type=script&lang=js&"
export * from "./Assinatura.js?vue&type=script&lang=js&"
import style0 from "./Assinatura.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QImg});
